import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, Flex } from "@mantine/core";
export const ChipList = ({ chips, lineBreaks = false, highlights }) => {
    return (_jsx(Flex, { style: {
            marginTop: "auto",
            marginBottom: "auto",
            display: "flex",
            flexWrap: "wrap",
            gap: "0.2rem"
        }, direction: lineBreaks ? "column" : "row", children: chips &&
            chips.map((chip, index) => (_jsx(Badge, { size: "sm", style: {
                    color: highlights?.includes(chip)
                        ? "var(--mantine-color-white)"
                        : "var(--mantine-color-black)",
                    backgroundColor: highlights?.includes(chip)
                        ? "var(--mantine-color-secondary-5)"
                        : "var(--mantine-color-gray-2)"
                }, children: chip }, index))) }));
};
